import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  Input,
  TemplateRef,
  ComponentFactoryResolver,
  ApplicationRef,
  EmbeddedViewRef,
  Injector,
  AfterViewInit,
  HostBinding,
} from '@angular/core';

import * as L from 'leaflet';
import { ILeafletLayer, LeafletLayer } from '@shared/leaflet/leaflet';
import { IEntityLocation } from '@entities/entity-location';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-leaflet',
  templateUrl: './leaflet.component.html',
  styles: [`:host { display: block; }`],
})
export class LeafletComponent implements OnInit, AfterViewInit {
  private leafletMap: any;
  @Input() @HostBinding('class') classCss = '';
  @Input() imagePath = '/assets/libs/leaflet/images/';
  @Input() defaultViewPoint = { lat: '10.801940', lng: '106.738450' };
  // @Input() defaultPopupContent = 'Oxanh Farm';
  @Input() popupTemplateRef: TemplateRef<any>;

  @Input() setViewMap: EventEmitter<any> = new EventEmitter();
  @Input() drawCircle: EventEmitter<any> = new EventEmitter();
  // @Input() drawPolygon: EventEmitter<any> = new EventEmitter();
  // @Input() drawGeoJson: EventEmitter<any> = new EventEmitter();

  @Output() load: EventEmitter<any> = new EventEmitter();
  @Output() popupOpen: EventEmitter<any> = new EventEmitter();
  @Output() clickLayer: EventEmitter<ILeafletLayer> = new EventEmitter();

  @ViewChild('map', { static: false }) map: ElementRef;
  // private defaultMarker: any;
  private defaultLatLng: any;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private http: HttpClient,
  ) {
    L.Icon.Default.imagePath = this.imagePath;
    this.defaultLatLng = L.latLng(
      this.defaultViewPoint.lat,
      this.defaultViewPoint.lng,
    );
    // this.defaultMarker = L.marker(this.defaultLatLng, {});
  }

  ngOnInit() {
    this.setViewMap.subscribe((point: IEntityLocation) =>
      this._setViewMap(point),
    );
    this.drawCircle.subscribe((points: IEntityLocation[]) =>
      this._drawCircle(points),
    );
    // this.drawGeoJson.subscribe((points: any[]) => this._drawGeoJson(points));
  }

  ngAfterViewInit() {
    this._drawMap();
    this.loadGeoJson();
  }

  private _setViewMap(point: IEntityLocation) {
    this.defaultLatLng = L.latLng(point.pixelX, point.pixelY);
    // this.leafletMap.setView(target, zoom);
  }

  private _drawMap() {
    // Height has to be set. You can do this in CSS too.
    this.map.nativeElement.style = `height:100%; width: 100%;`;
    // Define map
    this.leafletMap = L.map(this.map.nativeElement);
    // Add tiles map — CartoDB Voyager: English labels
    const tiles = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    });
    tiles.addTo(this.leafletMap);
    // Set map's center to target with zoom 14.

    // Place a marker on the same location.
    // this.defaultMarker.addTo(this.leafletMap);
    // this.defaultMarker.bindPopup('Oxanh Farm').openPopup();
    this.leafletMap.on('popupopen', (e) => this.popupOpen.emit(e));
    this.leafletMap.on('load', (e) => setTimeout(() => this.load.emit(e), 100));
    this.leafletMap.setView(this.defaultLatLng, 13);
  }

  // private _drawPolyline(points: any[]) {
  //   return L.polyline(points).addTo(this.leafletMap);
  // }
  private addMarkerWithIcon(point: IEntityLocation): void {
    console.log(point);
    // Define a custom icon
    const customIcon = L.icon({
      iconUrl: 'assets/images/logo-farm.png', // Path to your custom icon
      iconSize: [38, 38], // Size of the icon
      iconAnchor: [22, 38], // Point of the icon which will correspond to marker's location
      popupAnchor: [-3, -76], // Point from which the popup should open relative to the iconAnchor
    });
    // Create a marker with the custom icon
    const marker = L.marker([point.pixelX, point.pixelY], {
      icon: customIcon,
    }).addTo(this.leafletMap);
    // Optionally bind a popup to the marker
    marker.bindPopup(point.tbEntityName).openPopup();
  }

  private _drawCircle(points: IEntityLocation[]) {
    for (let index = 0; index < points.length; index++) {
      const element = points[index];
      L.circle([element.pixelX, element.pixelY], {
        color: 'none',
        fillColor: '#f03',
        fillOpacity: 0.5,
        radius: 0,
      }).addTo(this.leafletMap);
      // circle.bindPopup(point.tbEntityName).openPopup();
      this.addMarkerWithIcon(element);
    }
  }

  // private _drawGeoJson(json: any[]) {
  //   const geojsonMarkerOptions = {
  //     radius: 8,
  //     fillColor: '#ff7800',
  //     color: '#000',
  //     weight: 1,
  //     opacity: 1,
  //     fillOpacity: 0.8
  //   };

  //   const geometries = L.geoJSON(json, {
  //     style: function (feature) {
  //       switch (feature.properties.party) {
  //         case 'Republican': return {color: '#ff0000'};
  //         case 'Democrat': return {color: '#0000ff'};
  //       }
  //     },
  //     onEachFeature: (feature, layer) => {
  //       // does this feature have a property named popupContent?
  //       if (feature.properties) {
  //         if (feature.properties.popup) {
  //           const popupProps = feature.properties.popup;
  //           const popup = L.popup();
  //           if (popupProps.content) {
  //             popup.setContent(popupProps.content);
  //           } else if (popupProps.component) {
  //             const component = popupProps.component;
  //             const componentFactory = this.componentFactoryResolver.resolveComponentFactory<any>(component);
  //             const componentRef = componentFactory.create(this.injector);
  //             componentRef.instance.leafletLayer = new LeafletLayer(layer);

  //             this.applicationRef.attachView(componentRef.hostView);

  //             const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
  //               .rootNodes[0] as HTMLElement;
  //             popup.setContent(domElem);

  //             // this.applicationRef.detachView(componentRef.hostView);
  //             // componentRef.destroy();
  //           }

  //           if (this.popupTemplateRef && this.popupTemplateRef instanceof TemplateRef) {
  //           }
  //           layer.bindPopup(popup);
  //         }
  //         layer.on('click', () => this.clickLayer.emit(new LeafletLayer(layer)));
  //       }
  //     },
  //     pointToLayer: function (feature, latlng) {
  //       return L.circleMarker(latlng, geojsonMarkerOptions);
  //     },
  //   }).addTo(this.leafletMap);
  //   return geometries;
  // }
  private loadGeoJson(): void {
    // Biên giới Việt Nam
    this.http.get('assets/libs/gadm36_VNM_0.json').subscribe((geojson: any) => {
      L.geoJSON(geojson, {
        style: {
          color: '#007bff',
          weight: 2,
          opacity: 0.8,
          fillOpacity: 0.1,
        },
      }).addTo(this.leafletMap);
    });

    // Quần đảo Hoàng Sa (Việt Nam)
    // 1) Mask rectangle to cover Chinese text on tiles
    this.addOceanMask([[15.6, 110.8], [17.2, 113.2]]);
    // 2) GeoJSON boundary
    this.http.get('assets/libs/gadm36_XPI_0.json').subscribe((geojson: any) => {
      L.geoJSON(geojson, {
        style: {
          color: '#007bff',
          weight: 2,
          opacity: 0.8,
          fillOpacity: 0.1,
        },
      }).addTo(this.leafletMap);
      // 3) Vietnamese label
      this.addSovereigntyLabel(16.5, 112.0, 'Quần đảo Hoàng Sa\n(Việt Nam)');
    });

    // Quần đảo Trường Sa (Việt Nam)
    // 1) Mask rectangle to cover Chinese text on tiles
    this.addOceanMask([[7.5, 111.5], [12.5, 117.5]]);
    // 2) GeoJSON boundary
    this.http.get('assets/libs/gadm36_XSP_0.json').subscribe((geojson: any) => {
      L.geoJSON(geojson, {
        style: {
          color: '#007bff',
          weight: 2,
          opacity: 0.8,
          fillOpacity: 0.1,
        },
      }).addTo(this.leafletMap);
      // 3) Vietnamese label
      this.addSovereigntyLabel(10.0, 114.0, 'Quần đảo Trường Sa\n(Việt Nam)');
    });
  }

  /** Vẽ hình chữ nhật màu biển để che text trên tile */
  private addOceanMask(bounds: L.LatLngBoundsExpression): void {
    L.rectangle(bounds, {
      color: 'transparent',
      fillColor: '#d5e8eb',  // Exact CartoDB Voyager ocean color
      fillOpacity: 1.0,
      interactive: false,
    }).addTo(this.leafletMap);
  }

  private addSovereigntyLabel(lat: number, lng: number, text: string): void {
    const label = L.divIcon({
      className: 'sovereignty-label',
      html: `<div style="
        font-size: 11px;
        font-weight: 400;
        color: #546b78;
        text-align: center;
        white-space: pre-line;
        font-family: 'Roboto', 'Helvetica Neue', sans-serif;
        letter-spacing: 1px;
        pointer-events: none;
      ">${text}</div>`,
      iconSize: [180, 40],
      iconAnchor: [90, 20],
    });
    L.marker([lat, lng], { icon: label, interactive: false }).addTo(this.leafletMap);
  }
}
